export default (state = {}, action) => {

    switch (action.type) {

        case 'GETTING_PRAYER_REQUESTS':
            return Object.assign({},state,{
                ui: action.payload.ui
            })
        case 'POSTING_PRAYER_REQUESTS':
            return Object.assign({},state,{
                ui: action.payload.ui,
                uiNewRequest:'loading',
            })
        case 'GET_PRAYER_REQUESTS_ERROR':
        case 'POSTING_PRAYER_REQUESTS_ERROR':
            return Object.assign({},state,{
                ui: action.payload.ui,
                message: action.payload.message
            })
        case 'GET_PRAYER_REQUESTS_SUCCESS':
        case 'POSTING_PRAYER_REQUESTS_ERROR':
            return Object.assign({},state,{
                ui: action.payload.ui,
                requests: action.payload.requests
            })
        case 'POSTING_PRAYER_REQUESTS_SUCCESS':
            return Object.assign({},state,{
                uiNewRequest:'success',
            })

        case 'PRAYED_FOR_REQUEST_SUCCESS':
        return Object.assign({},state,{
            requests: action.payload.requests,

        })

        default:
            return state
    }
}
